import style from './TopupPage.css';
import AppBar from '../../components/shared/AppBar/AppBar';
import useAndroidBackPress from '../../hooks/back.listener.hook';
import { useEffect, useRef, useState } from 'preact/hooks';
import TopupView from './TopupView';
import ListingSkeleton from '../../components/shared/ListingSkeleton/ListingSkeleton';
import CardService from '../../services/card.service';
import NavigationUtils from '../../utils/navigation.utils';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';

export default function TopupPage({ organization }) {
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});

  const handleCloseClick = () => {
    NavigationUtils.endFlow();
  };

  const handleBackClick = () => {
    NavigationUtils.back();
  };

  const backRef = useRef(null);

  useAndroidBackPress(backRef.current, () => {
    backRef.current.props.onClick();
  });

  useEffect(() => {
    CardService.getSettings(organization)
      .then(({ data }) => {
        setLoading(false);
        setSettings(data);
      })
      .catch(() => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, []);
  return (
    <>
      <AppBar
        onCloseClick={handleCloseClick}
        onBackClick={handleBackClick}
        className="fixed-bar"
        closeRef={backRef}
      />

      <div className={style.container}>
        {loading ? (
          <ListingSkeleton className={style.main} />
        ) : (
          <TopupView settings={settings} />
        )}
      </div>
    </>
  );
}
